export const menu = [
	// {
	// 	label: 'My Account',
	// 	url: ''
	// },
	// {
	// 	label: 'Order History',
	// 	url: '/orders'
	// },
	// {
	// 	label: 'Subscriptions',
	// 	url: '/subscriptions'
	// },
	// {
	// 	label: 'Addresses',
	// 	url: '/addresses'
	// },
	// {
	// 	label: 'Payment Methods',
	// 	url: '/payment-methods'
	// },
	// {
	// 	label: 'Change Password',
	// 	url: '/change-password'
	// },
	{
		label: 'Settings',
		event: 'settings'
	},
	{
		divider: true
	},
	{
		label: 'Sign Out',
		event: 'sign-out'
	}
]
